<router-outlet></router-outlet>

<med-toasts-container></med-toasts-container>
